import React, { Component } from "react";
import {
  API_TOKEN_NAME,
  USER_ID,
  USER_ROLE,
  USER_EMAIL,
  LOGIN_PHONE_NUMBER,
  PATIENT_NAME,
  SEARCH_SELECTED_DOC_ID,
  SEARCH_SELECTED_DOC_NAME,
  SCHEDULE_DATE,
  IMAGE_URL,
  USER_LOCAL_ID,
} from "../../constants";
import { scAxios, scAxiosAdmin, scAxiosSMS } from "../..";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { startUserSession } from "../../userSession";
import uhlcare_logo from "../../images/uhlcare-logo.webp";
import uhl_logo from "../../images/UHL (2).webp";
import medix_logo from "../../images/medix-logo.webp";
import ma_rashed_logo from "../../images/ma rashed hospital.webp";
import mainlogo from "../../images/main-logo.webp";
import DatePicker from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";
//import doc from '../../images/doc.png';
import $ from "jquery";
import Moment from "moment";
import { MyContext } from "../MyProvider";
import PopupOTP from "./PopupOTP";

const linkPatientId = (id) => {
  return new Promise((resolve, reject) => {
    const req = scAxios.request(`/mmlogin?patientid=${id}`, {
      method: "get",
      headers: {
        Accept: "application/json",
        // Authorization: "Bearer " + localStorage.getItem(API_TOKEN_NAME),
      },
    });
    req.then((res) => resolve(res.data)).catch((err) => reject(err));
  });
};
const SendOTPMessage = (data) => {
  return new Promise((resolve, reject) => {
    const req = scAxiosSMS.request("/user/sendotp", {
      method: "post",
      headers: {
        Accept: "application/json",
      },
      params: {
        ...data,
      },
    });
    req.then((res) => resolve(res.data)).catch((err) => reject(err));
  });
};
const SaveOTPNumber = (data) => {
  return new Promise((resolve, reject) => {
    const req = scAxiosAdmin.request("/user/saveotpnumber", {
      method: "post",
      headers: {
        Accept: "application/json",
      },
      params: {
        ...data,
      },
    });
    req.then((res) => resolve(res.data)).catch((err) => reject(err));
  });
};
const alertStyle = {
  color: "red",
};
const input_field_css = {
  maxHeight: "50px",
  fontSize: "14px",
  borderColor: "#cccccc",
  borderRadius: "5px",
};
class LinkPatientIdPopup extends Component {
  static contextType = MyContext;
  state = {
    fields: {},
    errors: {},
    search_doctors: [],
    search_keywords: "",
    doctor_id: "",
    schedule_date: "",
    department_id: "",
    limit: 4,
    search_selected_doc_name: "",
    selectedDate: null,
    payment_type: "",
    privacy_policy: "",
    term_conditions: "",
    showOtpPopup: false,
    phone_number: "",
    user_local_id: "",
    user_id: "",
  };

  handleChange = (event) => {
    this.setState({
      [event.target.name]: event.target.value,
    });
    
  };

  handleSubmit = (event, props) => {
    event.preventDefault();

    const type = "patient_registration";
    const user_local_id = localStorage.getItem(USER_LOCAL_ID);
    const grand_total = 200;
    const total = 200;
    const payment_type = "sslCommerz";
    const status = 1;
    const currency = "BDT";
    const qty = 1;

    const sslCommerz_urls = {
      // null if payment_type is pay_at_uhl
      success_url: `${window.location.origin}/success`,
      fail_url: `${window.location.origin}/fail`,
      cancel_url: `${window.location.origin}/cancel`,
    };
    const data = {
      type,
      user_local_id,
      grand_total,
      total,
      payment_type,
      sslCommerz_urls,
      status,
      currency,
      qty,
    };
    const id = this.state.patientId;

    linkPatientId(id)
      .then((res) => {
        

        if (res[0].pmobile) {
          this.setState({ phone_number: res[0].pmobile });
          this.setState({
            user_local_id: localStorage.getItem(USER_LOCAL_ID),
          });
          this.setState({
            user_id: res[0].pid,
          });
          //let six_digit_random_number = Math.floor(100000 + Math.random() * 999999);
          let six_digit_random_number =
            Math.floor(Math.random() * 900000) + 100000;
          var encoded_otp = "";
          var otp_number = btoa(six_digit_random_number);
          for (let i = 0; i < otp_number.length; i++) {
            var a = otp_number.charCodeAt(i);
            var b = a ^ 10;
            encoded_otp += String.fromCharCode(b);
          }
          var new_encoded_otp = btoa(encoded_otp);
          let messageBody = "Your OTP is " + six_digit_random_number;
          var encoded = "";
          var messageBodyText = btoa(messageBody);
          for (let i = 0; i < messageBodyText.length; i++) {
            var c = messageBodyText.charCodeAt(i);
            var d = c ^ 10;
            encoded += String.fromCharCode(d);
          }
          var encoded_message_body = btoa(encoded);
          let csms_generate_number = Math.random()
            .toString(36)
            .substring(2, 11);
          let csmsId = csms_generate_number;
          const data = {
            phone_number: res[0].pmobile,
            message_body: encoded_message_body,
            csms_id: csmsId,
          };

          SendOTPMessage(data)
            .then((res) => {
              if (res.status) {
                this.saveOtp(new_encoded_otp);
                $(".register_popup").css("visibility", "hidden");
                $(".register_popup").removeClass("show");
                $(".otp_popup").css("visibility", "visible");
                $(".otp_popup").addClass("show");
                $(".modal-backdrop.fade.show").remove();
                $("body").css("overflow", "");
                $("body").css("padding-right", "");
                this.setState({ showOtpPopup: true });
                toast.success("Please enter OTP to complete online sign up", {
                  position: toast.POSITION.TOP_LEFT,
                });
              } else {
                toast.error("Otp Was Not Send", {
                  position: toast.POSITION.TOP_LEFT,
                });
              }
            })
            .catch((err) => {
              console.log(err);
            });
          this.setState({ showOtpPopup: true });
          $(".otp_popup").css("visibility", "visible");
          $(".otp_popup").addClass("show");
          $(".modal-backdrop.fade.show").remove();
          $("body").css("overflow", "");
          $("body").css("padding-right", "");
          //   window.location.href = res.data;
        } /* else {
          toast.error("Something went wrong.Please try again!", {
            position: toast.POSITION.BOTTOM_RIGHT,
          });
        } */
      })
      .catch((err) => {
        toast.error("Something went wrong.Please try again!", {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
      });
  };
  saveOtp = (otp) => {
    const data = {
      phone_number: this.state.phone_number,
      otp_number: otp,
    };
    SaveOTPNumber(data)
      .then((res) => {
        if (res.data === "success") {
        } else {
        }
      })
      .catch((err) => {
        toast.error("Error occured", {
          position: toast.POSITION.TOP_LEFT,
        });
      });
  };
  closePopup = (event) => {
    const { DoctorData } = this.context;
    DoctorData({});
    document.getElementById("offcanvasExample6").style.visibility = "hidden";
    document.getElementById("offcanvasExample6").classList.remove("show");
    $(".modal-backdrop.fade.show").remove();
    $("body").css("overflow", "");
    $("body").css("padding-right", "");
  };
  //   showPatientRegistrationPopup = () => {
  //     $(".patientRegister").css("visibility", "visible");
  //     $(".patientRegister").addClasses("offcanvas offcanvas-start show");
  //     $(".modal-backdrop.fade.show").remove();
  //     $("body").css("overflow", "");
  //     $("body").css("padding-right", "");
  //   };

  componentDidMount() {
    if (
      localStorage.getItem(SEARCH_SELECTED_DOC_NAME) &&
      localStorage.getItem(SEARCH_SELECTED_DOC_ID) &&
      localStorage.getItem(SCHEDULE_DATE)
    ) {
      document.getElementById("Schedule").disabled = false;
      document.getElementById("Schedule").style.background = "gray";
    }
    /* if (localStorage.getItem(SEARCH_SELECTED_DOC_NAME)) {
      this.refreshGetSearchDoctors(
        localStorage.getItem(SEARCH_SELECTED_DOC_NAME)
      );
    } */
  }
  render() {
    const user_data = {
      PhoneNumber: this.state.phone_number,
    };
    const user_local_id = this.state.user_local_id;
    const user_id = this.state.user_id;

    
    return (
      <div
        className="offcanvas offcanvas-start otp_reg"
        tabIndex="-1"
        id="offcanvasExample6"
        aria-labelledby="offcanvasExampleLabel6"
        style={{ visibility: "visible" }}
      >
        <div className="offcanvas-header">
          <h5 className="offcanvas-title" id="offcanvasExampleLabel6">
            {" "}
          </h5>
          <button
            type="button"
            className="btn-close text-reset"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
            onClick={this.closePopup}
          />
        </div>
        <div className="offcanvas-body">
          <div className="row text-center" id="logos">
            <div className="col-2 ">
              <img src={uhlcare_logo} alt="uhlcare-logo" />
            </div>
            <div className="col-2">
              <img src={mainlogo} alt="medix-logo" />
            </div>
            <div className="col-2">
              <img src={uhl_logo} alt="uhl-logo" />
            </div>
            <div className="col-2">
              <img src={medix_logo} alt="medix-logo" />
            </div>

            <div className="col-2">
              <img src={ma_rashed_logo} alt="medix-logo" />
            </div>
          </div>
          <div className="left-offcanvas">
            <h4 style={{ color: "#187979" }}>Link Patient ID</h4>
            <form
              onSubmit={this.handleSubmit}
              id="registerform"
              className="needs-validation"
              noValidate
            >
              <div className="row">
                <div className="input-group mt-2">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Your Patient ID"
                    name="patientId"
                    id="patientId"
                    onChange={this.handleChange}
                    required
                    autoComplete="off"
                    style={input_field_css}
                  />
                </div>
                <span style={alertStyle}>{this.state.errors.patientId}</span>
              </div>

              <div className="row mt-2">
                <div className="col-12">
                  <button
                    variant="primary"
                    type="submit"
                    className="btn-links appointment-new submit_btn"
                    id="black-btn"
                  >
                    {" "}
                    Link ID{" "}
                  </button>
                </div>
              </div>
            </form>
            <p>
              <label className="dont">
                Don't have a patient ID? <br />
                <button
                  className="nav-link active"
                  onClick={this.showPatientRegistrationPopup}
                  style={{
                    background: "none",
                    border: "none",
                    padding: "0px",
                    color: "rgb(251, 98, 1)",
                  }}
                >
                  Get a Patient ID.
                </button>
              </label>
            </p>
          </div>
        </div>
        {this.state.showOtpPopup ? (
          <PopupOTP
            showPopup={this.state.showOtpPopup}
            userData={user_data}
            userId={user_local_id}
            userPatientId={user_id}
            from={"from_link_id"}
          />
        ) : null}
      </div>
    );
  }
}
export default LinkPatientIdPopup;



// WEBPACK FOOTER //
// ./src/component/frontend/LinkPatientIdPopup.js